import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { push } from 'react-router-redux'
import axios from 'axios'

// Styles
import styles from './styles'

// Material UI
import { withStyles } from 'material-ui/styles'
import Typography from 'material-ui/Typography'
import Button from 'material-ui/Button'
import Drawer from 'material-ui/Drawer'
import { List, ListItem, ListItemIcon, ListItemText } from 'material-ui/List'
import Divider from 'material-ui/Divider'

// Actions
import {
  closePrioritiesDrawer,
  itemPriorityChange,
  loadedData,
  ommitItem
} from './actions'

class PrioritiesDrawer extends Component {
  constructor(props) {
    super(props)

    this.state = {}
  }

  removeWhite(data) {
    let access_id = data['access id']

    let url = `https://api.dsnapis.com/customer/${
      this.props.customer_number
    }/pw/teSt1/profileid/${access_id}/colorid/4/db/2`
    console.log('remove white' + url)

    axios.get(url).then(function(response) {
      //alert("received")
    })
  }

  onWaiting(data) {
    /*
    let index = this.props.rrd_data.indexOf(data);
    let rrd_data = this.props.rrd_data;
    data["Dsc_ID"] = 3;
    rrd_data[index] = data;
    this.props.loadedData(rrd_data)
    */

    var access_id = data['access id']
    let current_data = this.props.priority_change_array

    const result = current_data.find(
      item => item.access_id === data['access id']
    )

    if (result) {
      let index = current_data.indexOf(result)
      current_data.splice(index, 1)
    }

    let new_data = {
      access_id: access_id,
      new_priority: 3,
      color_id: 4
    }
    current_data.push(new_data)
    this.props.itemPriorityChange(current_data)

    // Ommits
    let ommitted_data = this.props.items_ommitted
    const result_ommit = ommitted_data.find(
      item => item.access_id === data['access id']
    )
    if (result_ommit) {
      let ind = ommitted_data.indexOf(result_ommit)
      ommitted_data.splice(ind, 1)
      this.props.ommitItem(ommitted_data)
    }

    if (this.props.customer_number && access_id) {
      let url = `https://api.dsnapis.com/customer/${
        this.props.customer_number
      }/pw/teSt1/profileid/${access_id}/dscid/3/db/2`
      console.log('waiting url is' + url)

      let myComponent = this
      axios
        .get(url)
        .then(function(response) {
          console.log('done code change.')
          myComponent.removeWhite(data)
        })
        .catch(function(error) {
          console.log(error)
        })
    }
  }

  onDating(data) {
    /*
    let index = this.props.rrd_data.indexOf(data);
    let rrd_data = this.props.rrd_data;
    data["Dsc_ID"] = 1;
    rrd_data[index] = data;
    this.props.loadedData(rrd_data)*/

    var access_id = data['access id']
    let current_data = this.props.priority_change_array

    const result = current_data.find(
      item => item.access_id === data['access id']
    )

    if (result) {
      let index = current_data.indexOf(result)
      current_data.splice(index, 1)
    }

    let new_data = {
      access_id: access_id,
      new_priority: 1,
      color_id: 4
    }
    current_data.push(new_data)
    this.props.itemPriorityChange(current_data)

    // Ommits
    let ommitted_data = this.props.items_ommitted
    const result_ommit = ommitted_data.find(
      item => item.access_id === data['access id']
    )
    if (result_ommit) {
      let ind = ommitted_data.indexOf(result_ommit)
      ommitted_data.splice(ind, 1)
      this.props.ommitItem(ommitted_data)
    }

    let myComponent = this
    axios
      .get(
        'https://api.dsnapis.com/customer/' +
          this.props.customer_number +
          '/pw/teSt1/profileid/' +
          access_id +
          '/dscid/1/db/2'
      )
      .then(function(response) {
        console.log('done code change.')
        myComponent.removeWhite(data)
      })
      .catch(function(error) {
        console.log(error)
      })
  }

  onPursuing(data) {
    /*
    let index = this.props.rrd_data.indexOf(data);
    let rrd_data = this.props.rrd_data;
    data["Dsc_ID"] = 2;
    rrd_data[index] = data;
    this.props.loadedData(rrd_data)
*/

    var access_id = data['access id']
    let current_data = this.props.priority_change_array

    const result = current_data.find(
      item => item.access_id === data['access id']
    )

    if (result) {
      let index = current_data.indexOf(result)
      current_data.splice(index, 1)
    }

    let new_data = {
      access_id: access_id,
      new_priority: 2,
      color_id: 4
    }
    current_data.push(new_data)
    this.props.itemPriorityChange(current_data)

    // Ommits
    let ommitted_data = this.props.items_ommitted
    const result_ommit = ommitted_data.find(
      item => item.access_id === data['access id']
    )
    if (result_ommit) {
      let ind = ommitted_data.indexOf(result_ommit)
      ommitted_data.splice(ind, 1)
      this.props.ommitItem(ommitted_data)
    }

    let myComponent = this
    axios
      .get(
        'https://api.dsnapis.com/customer/' +
          this.props.customer_number +
          '/pw/teSt1/profileid/' +
          access_id +
          '/dscid/2/db/2'
      )
      .then(function(response) {
        console.log('done code change.')
        myComponent.removeWhite(data)
      })
      .catch(function(error) {
        console.log(error)
      })
  }

  onGaveUp(data) {
    /*
    let index = this.props.rrd_data.indexOf(data);
    let rrd_data = this.props.rrd_data;
    data["Dsc_ID"] = 4;
    rrd_data[index] = data;
    this.props.loadedData(rrd_data)*/

    var access_id = data['access id']
    let current_data = this.props.priority_change_array

    const result = current_data.find(
      item => item.access_id === data['access id']
    )

    if (result) {
      let index = current_data.indexOf(result)
      current_data.splice(index, 1)
    }

    let new_data = {
      access_id: access_id,
      new_priority: 4,
      color_id: 4
    }
    current_data.push(new_data)
    this.props.itemPriorityChange(current_data)

    // Ommits
    let ommitted_data = this.props.items_ommitted
    const result_ommit = ommitted_data.find(
      item => item.access_id === data['access id']
    )
    if (result_ommit) {
      let ind = ommitted_data.indexOf(result_ommit)
      ommitted_data.splice(ind, 1)
      this.props.ommitItem(ommitted_data)
    }

    let myComponent = this
    axios
      .get(
        'https://api.dsnapis.com/customer/' +
          this.props.customer_number +
          '/pw/teSt1/profileid/' +
          access_id +
          '/dscid/4/db/2'
      )
      .then(function(response) {
        console.log('done code change.')
        myComponent.removeWhite(data)
      })
      .catch(function(error) {
        console.log(error)
      })
  }

  render() {
    const { classes, theme, location, priorityData } = this.props

    var localData = {}
    if (priorityData) {
      localData = priorityData
    }

    const prioritiesList = (
      <div className={classes.listFull}>
        <Typography
          type="subheading"
          color="inherit"
          className={classes.drawerTitle}
        >
          Set Priority Code
        </Typography>
        <Divider />
        <div className={classes.buttons}>
          <Button
            onClick={() => this.onDating(localData)}
            disableRipple
            className={classes.whiteText}
          >
            DATING
          </Button>
          <Button
            onClick={() => this.onPursuing(localData)}
            disableRipple
            className={classes.priorityLightGreen}
          >
            PURSUING
          </Button>
          <Button
            onClick={() => this.onWaiting(localData)}
            disableRipple
            className={classes.priorityGreen}
          >
            WAITING
          </Button>
          <Button
            onClick={() => this.onGaveUp(localData)}
            disableRipple
            className={classes.priorityRed}
          >
            GAVE-UP
          </Button>
        </div>
        <div className={classes.cancel}>
          <Button
            color="primary"
            className={classes.button}
            onClick={() => this.props.closePrioritiesDrawer()}
          >
            Cancel
          </Button>
        </div>
      </div>
    )

    return (
      <div className={classes.after}>
        <Drawer
          anchor="bottom"
          open={this.props.priority}
          onRequestClose={() => this.props.closePrioritiesDrawer()}
          className={classes.after}
        >
          <div
            onClick={() => this.props.closePrioritiesDrawer()}
            onKeyDown={() => this.props.closePrioritiesDrawer()}
          >
            {prioritiesList}
          </div>
        </Drawer>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    customer_number: state.customer.number,
    project_id: state.prefix.project_id,
    router: state.router,
    priority: state.dashboard.priority,
    priorityData: state.dashboard.priorityData,
    rrd_data: state.rrd_data,
    items_ommitted: state.item_ommitted,
    priority_change_array: state.prioritychangeid
  }
}

function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      closePrioritiesDrawer: closePrioritiesDrawer,
      ommitItem: ommitItem,
      itemPriorityChange: itemPriorityChange,
      loadedData: loadedData
    },
    dispatch
  )
}

export default withRouter(
  withStyles(styles, { withTheme: true })(
    connect(mapStateToProps, matchDispatchToProps)(PrioritiesDrawer)
  )
)



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/PrioritiesDrawer/index.js